import './app.css';
import {renderApp} from './app.js';

const root = document.getElementById('root');

try {
    renderApp(root);
} catch (err) {
    console.error('Initial render failed:', err);
    root.innerHTML = `
        <div style="padding: 40px; text-align: center; font-family: sans-serif">
            <h1>Something went wrong.</h1>
            <p>Please refresh the page. If the problem persists, visit
                <a href="https://shop.snapplify.com">shop.snapplify.com</a>.
            </p>
        </div>
    `;
}

// Catch runtime exceptions and unhandled promise rejections.
// TODO: forward to Airbrake once the package is wired (roadmap → Other tracks: GTM governance + observability).
window.addEventListener('error', (event) => {
    console.error('Uncaught error:', event.error || event.message);
});
window.addEventListener('unhandledrejection', (event) => {
    console.error('Unhandled rejection:', event.reason);
});
